import React, { useEffect, useRef } from 'react';
import '../pages/jobDescription.css';

interface MatchScoreBarProps {
  score: number;
}

const MatchScoreBar: React.FC<MatchScoreBarProps> = ({ score }) => {
  // Score should be between 0 and 1
  const normalizedScore = Math.max(0, Math.min(1, score));
  const percentScore = Math.round(normalizedScore * 100);
  
  const scoreBarRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (scoreBarRef.current) {
      // Set CSS variable for width
      scoreBarRef.current.style.setProperty('--score-width', `${percentScore}%`);
    }
  }, [percentScore]);
  
  return (
    <div className="score-bar-container">
      <div 
        ref={scoreBarRef}
        className={`score-bar ${
          normalizedScore > 0.7 ? 'score-bar-green' : 
          normalizedScore > 0.4 ? 'score-bar-yellow' : 'score-bar-red'
        }`}
      ></div>
    </div>
  );
};

export default MatchScoreBar;
